import DialogAnimate from "src/components/animate/DialogAnimate";
import InfoActionDialog from "src/components/InfoActionDialog";
import useLocales from "src/hooks/useLocales";
import { EntitiyType } from "src/types/apps";

import useModifyMaintanance from "./useModifyMaintanance";

// ----------------------------------------------------------------------

type Props = {
	onClose: (isSuccess?: boolean) => void;
	entity: EntitiyType | null;
};

export const ModifyEntityDialog = ({ onClose, entity }: Props) => {
	const { translate } = useLocales();

	const { changeEntity, isLoading } = useModifyMaintanance(onClose);

	return (
		<DialogAnimate maxWidth={"xs"} onClose={onClose} open={!!entity}>
			<InfoActionDialog
				acceptTitle={translate("Cambiar estado")}
				cancelTitle={translate("Cancelar")}
				description={translate("Se verá reflejado en el listo de entidades de los usuarios.")}
				onAccept={() => changeEntity(entity?.id ?? "", !entity?.maintenance)}
				onCancel={onClose}
				title={translate("¿Estás seguro?")}
				loading={isLoading}
			/>
		</DialogAnimate>
	);
};

export default ModifyEntityDialog;
